module.exports = __webpack_public_path__ + "static/developpeur-mobile.968dec48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/developpeur-mobile.jpg
// module id = 789
// module chunks = 19817326959855